module.exports = __webpack_public_path__ + "img/horizontal_3_5_pp3_3009.27bd9389.png";